import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const ReviewSection = ({ title, summary, confidence, evidenceKeys, evidenceSnapshot, icon, colorClass, actionProps }) => {
  const [expanded, setExpanded] = useState(false);

  if (!title || !summary) return null;

  const validEvidence = (evidenceKeys || [])
    .map(key => evidenceSnapshot.find(e => e.key === key))
    .filter(Boolean);

  const renderConfidence = () => {
    if (!confidence) return null;
    
    if (confidence === 'strong_evidence') {
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-green-100 text-green-700">
          <SafeIcon icon={FiIcons.FiCheckCircle} className="mr-1" /> Strong Evidence
        </span>
      );
    }
    if (confidence === 'emerging_pattern') {
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-blue-100 text-blue-700">
          <SafeIcon icon={FiIcons.FiTrendingUp} className="mr-1" /> Emerging Pattern
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-slate-100 text-slate-600">
        Not enough data
      </span>
    );
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden transition-all hover:shadow-md">
      <div className="p-6">
        <div className="flex items-start gap-4">
          {icon && (
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${colorClass}`}>
              <SafeIcon icon={icon} className="text-2xl" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
              <h3 className="text-lg font-bold text-slate-900">{title}</h3>
              {renderConfidence()}
            </div>
            <p className="text-slate-700 leading-relaxed text-sm md:text-base">{summary}</p>
            
            {actionProps && (
              <div className="mt-4">
                <button 
                  onClick={actionProps.onClick}
                  className="text-sm font-bold text-blue-600 hover:text-blue-800 flex items-center"
                >
                  {actionProps.label} <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {validEvidence.length > 0 && (
        <div className="border-t border-slate-100">
          <button 
            onClick={() => setExpanded(!expanded)}
            className="w-full px-6 py-3 flex items-center justify-between text-sm font-medium text-slate-500 hover:bg-slate-50 hover:text-slate-900 transition-colors"
          >
            <span>Why? (Evidence)</span>
            <SafeIcon icon={expanded ? FiIcons.FiChevronUp : FiIcons.FiChevronDown} />
          </button>
          
          {expanded && (
            <div className="px-6 pb-4 bg-slate-50 border-t border-slate-100 pt-4">
              <ul className="space-y-2">
                {validEvidence.map((ev, idx) => (
                  <li key={idx} className="flex items-start text-sm text-slate-700">
                    <span className="text-slate-400 mr-2 mt-0.5">•</span>
                    <span>{ev.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};